export const isEmailValid = (email) => {
  // RFC 5322 official standard regular expression to validate email addresses
  const emailRegex = new RegExp(
    "([-!#-'*+/-9=?A-Z^-~]+(\\.[-!#-'*+/-9=?A-Z^-~]+)*|\"([]!#-[^-~ \\t]|(\\\\[\\t -~]))+\")@([-!#-'*+/-9=?A-Z^-~]+(\\.[-!#-'*+/-9=?A-Z^-~]+)*|\\[[\\t -Z^-~]*])",
    "i"
  );
  return emailRegex.test(email);
};
